import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { Course } from "../model/course";
import { map, delay } from "rxjs/operators";
import { Lesson } from "../model/lesson";
import { Recordings } from "../model/recordings";
import { Detgrabs } from "../model/detgrab";
import { environment } from "../../environments/environment";
@Injectable()
export class CoursesService {
  tokenFF: string = "";
  constructor(private http: HttpClient) {}

  findCourseById(courseId: number): Observable<Course> {
    return this.http.get<Course>(`/api/courses/${courseId}`);
  }

  findAllCourses(): Observable<Course[]> {
    let items = this.getInitData();
    return of(items).pipe(delay(500));
  }

  findAllCourseLessons(courseId: number): Observable<Lesson[]> {
    return this.http
      .get("/api/lessons", {
        params: new HttpParams()
          .set("courseId", courseId.toString())
          .set("pageNumber", "0")
          .set("pageSize", "1000"),
      })
      .pipe(map((res) => res["payload"]));
  }

  findLessons(
    courseId: number,
    sortOrder = "asc",
    pageNumber = 0,
    pageSize = 3,
    sortColumn = "seqNo"
  ): Observable<Lesson[]> {
    return this.http
      .get("/api/lessons", {
        params: new HttpParams()
          .set("courseId", courseId.toString())
          .set("sortOrder", sortOrder)
          .set("pageNumber", pageNumber.toString())
          .set("pageSize", pageSize.toString())
          .set("sortColumn", sortColumn),
      })
      .pipe(map((res) => res["payload"]));
  }

  findRecords(): Observable<Recordings[]> {
    return this.http
      .get("https://jsonplaceholder.typicode.com/posts", {})
      .pipe(map((res) => res["payload"]));
  }

  getTokenG(token: string) {
    this.tokenFF = token;
  }

  getInitData() {
    return [
      {
        id: 11,
        description: "Consulta Grabaciones Históricas Banco Pichincha",
        category: "BEGINNER",
        //iconUrl: 'https://s3-us-west-1.amazonaws.com/angular-university/course-images/angular-material-course-1.jpg',
        iconUrl:
          "https://img.freepik.com/free-photo/digital-cloud-data-storage-digital-concept-cloudscape-digital-online-service-global-network-database-backup-computer-infrastructure-technology-solution_90220-1046.jpg?w=900&t=st=1705611630~exp=1705612230~hmac=abfad58f0c2e8841d426609646d7ca192a61a0d43fbee068f44ea623678bfa48",
        courseListIcon: "string",
        longDescription: "",
        lessonsCount: 11,
      },
    ];
  }

  getRecords(record: Recordings): Observable<Detgrabs[]> {
    const startDate = record.fecha;
    const endDate = record.fechafin;
    const arrayUsers = record.usuarios;
    const arrayColas = record.colas;
    const arrayDirs = record.direccion;
    const arrayCamps = record.campania;
    const arrayCLs = record.contactlist;

    let ani = record.ani;
    let dnis = record.dnis;
    let identificacion = record.identificacion;
    let users = [];
    let colas = [];
    let direccion = [];
    let campania = [];
    let cl = [];
    let dir = "";

    let date1 = new Date(startDate);
    let fechaInicio = date1.toISOString();
    const date2 = new Date(endDate);
    date2.setTime(date2.getTime() + 24 * 60 * 60 * 1000);
    let fechaFin = date2.toISOString();
    let resultUsers = [];
    let resultQueues = [];
    let resultDirs = [];
    let resultCamps = [];
    let resultCLs = [];
    if (record.fecha == null) {
      date1 = new Date(Date.now());
      fechaInicio = date1.toISOString();
    }
    if (record.fechafin == null) {
      date1 = new Date(Date.now());
      date1.setTime(date1.getTime() + 24 * 60 * 60 * 1000);
      fechaFin = date1.toISOString();
    }
    if (record.ani == null) {
      ani = "";
    }

    if (record.dnis == null) {
      dnis = "";
    }

    if (identificacion == null) {
      identificacion = "";
    }

    Object.keys(arrayColas).forEach((k) => resultQueues.push(arrayColas[k]));
    Object.keys(arrayUsers).forEach((k) => resultUsers.push(arrayUsers[k]));
    Object.keys(arrayDirs).forEach((k) => resultDirs.push(arrayDirs[k]));
    if (arrayCamps != null) {
      Object.keys(arrayCamps).forEach((k) => resultCamps.push(arrayCamps[k]));
    }
    if (arrayCLs != null) {
      Object.keys(arrayCLs).forEach((k) => resultCLs.push(arrayCLs[k]));
    }
    if (resultQueues != null) {
      resultQueues.forEach(({ id }) => {
        colas.push(id);
      });
    }
    if (resultUsers != null) {
      resultUsers.forEach(({ item_id }) => {
        users.push(item_id);
      });
    }
    if (resultCamps != null) {
      resultCamps.forEach(({ item_id }) => {
        campania.push(item_id);
      });
    }
    if (resultCLs != null) {
      resultCLs.forEach(({ item_id }) => {
        cl.push(item_id);
      });
    }
    if (resultDirs != null) {
      resultDirs.forEach(({ item_id }) => {
        direccion.push(item_id);
      });
    }
    if (direccion[0] === "2") {
      dir = "inbound";
    }
    if (direccion[0] === "3") {
      dir = "outbound";
    }
    let person = {
      StartDate: fechaInicio,
      EndDate: fechaFin,
      QueuesId: colas,
      Ani: ani,
      Dnis: dnis,
      UserId: users,
      Identificacion: identificacion,
      Direction: dir,
      IdCampagin: campania,
      IdList: cl,
    };
    const body = JSON.stringify(person);
    return this.http
      .post<Detgrabs[]>(environment.downloadRecords, body)
      .pipe(map((res) => res["message"]));
  }

  async getDownloadZIP(downloadlist) {
    try {
      return await this.http
        .post(environment.downloadZip, downloadlist)
        .pipe(map((res) => res["menssage"]))
        .toPromise();
    } catch (error) {
      alert("Error en la descarga");
    }
  }

  async enviarDatos(url: string, datos: any) {
    try {
      return await this.http.post(url, datos).pipe().toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
